<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-8">
      <h1>{{ $t('adm.permits.action_dates.title') }}</h1>
      <i-button
        type="primary"
        size="medium"
        @click="isAddActionDateDialogOpen = true"
      >
        <icon-plus class="tw-mr-2" />
        {{ $t('adm.permits.action_dates.action_date_dialog.title_new') }}
      </i-button>
    </div>

    <div v-loading="isLoading">
      <div
        class="tw-overflow-auto"
      >
        <AdministrationTableList
          store-path="v2/admin/cms/permitManagement/actionDates"
          list-relative-path="actionDates"
          list-item-component-name="PermitActionDateListItem"
          list-item-prop-name="actionDate"
          :columns="columns"
        />
      </div>
      <AdministrationTablePagination
        store-path="v2/admin/cms/permitManagement/actionDates"
        filter-relative-path="filters"
      />
    </div>

    <AddPermitActionDateDialog
      :is-open="isAddActionDateDialogOpen"
      @close="isAddActionDateDialogOpen = false"
      @refresh="load"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AdministrationTableList from '@/components/Administration/components/AdministrationTableList.vue';
import { actionDatesTableColumns } from '@/components/Administration/PermitManagement/ActionDates/constants';
import AddPermitActionDateDialog from '@/components/Administration/PermitManagement/ActionDates/AddPermitActionDateDialog.vue';
import { mapState } from 'vuex';

export default {
  name: 'PermitActionDatesV2',
  components: {
    AddPermitActionDateDialog,
    AdministrationTablePagination,
    AdministrationTableList,
    ForeignersMessagingPopover,
  },
  data() {
    return {
      isAddActionDateDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.permitManagement.actionDates.filters,
      isLoading: (state) => state.v2.admin.cms.permitManagement.actionDates.isLoading,
    }),
    columns() {
      return actionDatesTableColumns;
    },
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/permitManagement/actionDates/load');
    },
  },
};
</script>
